import { getAuthenticationHeader } from '@fenderdigital/custom-hooks/lib/cognito';

export interface AuthorizationHeaders {
  headers: {
    'Content-Type': string;
    Accept: string;
    Authorization?: string;
  };
}

export default class AuthorizationHeader {
  static async getCognitoHeader(version = '3.1.0'): Promise<AuthorizationHeaders> {
    const authorizationHeader: AuthorizationHeaders = {
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json; version=${version}`,
      },
    };
    try {
      const token = await getAuthenticationHeader(true);
      authorizationHeader.headers.Authorization = `Bearer ${token}`;
      return authorizationHeader;
    } catch (err) {
      console.error('Fetch to cognito token failed: ', err);
      return authorizationHeader;
    }
  }
}
